import Tastet from '../tastet.js';
import Modal from './modal.js';

const STORAGE_KEY = 'tastet_region';
// Sentinel stored when the user picked "All cities" — keeps auto-open from
// firing again. Not in REGION_WHITELIST, so setup.php will not redirect on it.
const ALL_CITIES_SENTINEL = 'all';

export default class RegionModal extends Modal {
  init($el, data) {
    data = this.set(data || {}, {
      alias: 'modal',
      openSelector: "[data-action='show_region']",
      closeSelector: '[data-action="close"]',
    });
    super.init($el, data);
  }

  addEvents() {
    super.addEvents();
    var data = this.get();

    this.on(this.$inner, 'click', {
      delegate: '.region-list--item',
      callback: this.region_onClick,
    });

    this.$trigger = this.$(data.openSelector);
    this._autoOpenFirstVisit();
  }

  // events ----------------------------------------------------------------------------------------------------------
  // Product decision: switching city always redirects to the language-aware
  // home page — current path, other query params, and hash are intentionally
  // dropped. pll_home_url() handles the locale prefix.
  region_onClick(e) {
    var btn = e.target;
    if (!btn || btn.disabled) return;
    var value = btn.getAttribute('data-region') || '';
    var home = this.get('home') || '/';

    try {
      localStorage.setItem(STORAGE_KEY, value || ALL_CITIES_SENTINEL);
    } catch (err) {
      // localStorage may throw in private mode — fall through to navigation.
    }

    var target = value ? home + '?region=' + encodeURIComponent(value) : home;

    // Same-URL assignment is a no-op; force a reload so setup.php re-runs.
    if (window.location.href === target) {
      window.location.reload();
    } else {
      window.location.href = target;
    }
  }

  // Block overlay + cancel dismissal when forced (first visit, no city picked yet)
  background_onClick() {
    if (this._isForced()) return;
    super.background_onClick();
  }

  close_onClick(e) {
    if (this._isForced()) return;
    super.close_onClick(e);
  }

  // methods ---------------------------------------------------------------------------------------------------------
  open(options) {
    super.open(options);
    if (this.$trigger && this.$trigger.length) {
      this.$trigger.attr('aria-expanded', 'true');
    }
  }

  close() {
    super.close();
    if (this.$trigger && this.$trigger.length) {
      this.$trigger.attr('aria-expanded', 'false');
    }
  }

  _isForced() {
    return this.$inner.hasClass('is-forced');
  }

  // The city gate opts out of Modal's cookie-cooldown auto-open: it has its own
  // rule below (localStorage, homepage-only, non-dismissable) and must keep
  // showing on every visit until a city is actually picked. Runs from
  // addEvents() instead, once $trigger exists.
  _maybeAutoOpen() {}

  // Auto-open only fires on the homepage (data-auto-open="true" set by the
  // Blade template via is_front_page()). On every other page the user opens
  // the modal manually via the header trigger.
  // setup.php's wp_head script syncs ?region= ↔ localStorage before DOM is ready,
  // so by the time we run, storage reflects the final state.
  _autoOpenFirstVisit() {
    if (this.get('autoOpen') !== true) return;

    var saved;
    try {
      saved = localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return;
    }
    if (saved) return;

    this.$inner.addClass('is-forced');

    // Fresh visitor: clear the pre-selected "All cities" disabled/checkmark state
    // so the modal doesn't show the first option as "already selected".
    var inner = this.$inner.get && this.$inner.get(0);
    if (inner) {
      var items = inner.querySelectorAll('.region-list--item[disabled]');
      for (var i = 0; i < items.length; i++) {
        items[i].disabled = false;
        items[i].removeAttribute('aria-current');
        var check = items[i].querySelector('.region-list--check');
        if (check && check.parentNode) {
          check.parentNode.removeChild(check);
        }
      }
    }

    this.open();
  }
}

Tastet.Modules.RegionModal = RegionModal;
